export default __webpack_public_path__ + "static/media/check.6e4045be.gif";